<template>
  <v-row justify="center" class="signup-form">
    <v-col cols="12" sm="8" md="6">
      <transition name="slide-fade" mode="out-in">
        <LegacyValidationEmailCard
          v-if="!hasValidatedEmailAndPass"
          key="validation-form"
          @validated="validatedHandler"
        />
        <LegacyValidationPasswordCard
          v-else
          key="password-form"
          @back="hasValidatedEmailAndPass = false"
          :email="email"
          :phone="phone"
        />
      </transition>
    </v-col>
  </v-row>
</template>

<script>
import LegacyValidationEmailCard from '@/components/LegacyValidationEmailCard'
import LegacyValidationPasswordCard from '@/components/LegacyValidationPasswordCard'
export default {
  name: 'LegacyAccountUpdate',
  components: { LegacyValidationEmailCard, LegacyValidationPasswordCard },
  data: () => {
    return {
      hasValidatedEmailAndPass: false,
      isLoading: false,
      phone: '',
      email: '',
    }
  },
  methods: {
    validatedHandler({ email, phone }) {
      this.hasValidatedEmailAndPass = true
      this.email = email
      this.phone = phone
    }, // validatedHandler
    unauthorizedHandler() {
      this.hasValidatedEmailAndPass = false
    }, // unauthorizedHandler
  }, // methods
}
</script>

<style lang="css">
.signup-form input {
  font-size: 2em;
  line-height: 1.3;
  max-height: none;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  /* transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1); */
  transition: all 0.3s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
